/* DSTRSD theme JS */
(function () {
  'use strict';

  /* ── nav scroll ── */
  function initNav() {
    var nav = document.querySelector('.dstrsd-nav');
    if (!nav) return;
    function tick() {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ── countdown ── */
  function initCountdown() {
    var el = document.getElementById('dstrsd-countdown');
    if (!el) return;

    var target = new Date(el.dataset.target || '2026-06-15T12:00:00-07:00').getTime();

    function calc() {
      var diff = target - Date.now();
      if (diff <= 0) return null;
      return {
        d: Math.floor(diff / 86400000),
        h: Math.floor(diff % 86400000 / 3600000),
        m: Math.floor(diff % 3600000 / 60000),
        s: Math.floor(diff % 60000 / 1000)
      };
    }

    function pad(n, w) {
      return String(n).padStart(w || 2, '0');
    }

    function render(t) {
      if (!t) {
        el.innerHTML = '<span class="dstrsd-countdown-done">Live now.</span>';
        return;
      }
      var cells = [
        { v: pad(t.d, t.d > 99 ? 3 : 2), l: 'Days' },
        { v: pad(t.h), l: 'Hours' },
        { v: pad(t.m), l: 'Minutes' },
        { v: pad(t.s), l: 'Seconds' }
      ];
      var html = '';
      cells.forEach(function (c, i) {
        html += '<div class="dstrsd-cd-cell">';
        html += '<span class="dstrsd-cd-num">' + c.v + '</span>';
        html += '<span class="dstrsd-cd-lbl">' + c.l + '</span>';
        html += '</div>';
        if (i < cells.length - 1) {
          html += '<span class="dstrsd-cd-sep" aria-hidden="true">:</span>';
        }
      });
      el.innerHTML = html;
      el.setAttribute('aria-label', t.d + ' days, ' + t.h + ' hours, ' + t.m + ' minutes, ' + t.s + ' seconds until drop');
    }

    render(calc());
    setInterval(function () { render(calc()); }, 1000);
  }

  /* ── intro modal ── */
  function initIntro() {
    var overlay = document.getElementById('dstrsd-intro');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('.dstrsd-intro__close');
    var skipLink = overlay.querySelector('[data-intro-skip]');
    var form = overlay.querySelector('.dstrsd-intro__form-el');
    var input = overlay.querySelector('.dstrsd-intro__input');
    var formWrap = overlay.querySelector('[data-intro-form]');
    var successWrap = overlay.querySelector('[data-intro-success]');
    var SESSION_KEY = 'dstrsd_intro_seen_v1';

    function open() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    function showSuccess() {
      if (formWrap) formWrap.style.display = 'none';
      if (successWrap) successWrap.style.display = 'block';
      setTimeout(close, 1800);
    }

    /* phone formatting */
    if (input) {
      input.addEventListener('input', function () {
        var raw = input.value.replace(/\D/g, '').slice(0, 10);
        var fmt = raw;
        if (raw.length > 6) fmt = raw.slice(0, 3) + ' ' + raw.slice(3, 6) + ' ' + raw.slice(6);
        else if (raw.length > 3) fmt = raw.slice(0, 3) + ' ' + raw.slice(3);
        input.value = fmt;
      });
    }

    /* form submit */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!input) return;
        var digits = input.value.replace(/\D/g, '');
        if (digits.length < 7) return;

        var smsEndpoint = overlay.dataset.smsEndpoint;
        var klaviyoListId = overlay.dataset.klaviyoListId;

        if (klaviyoListId) {
          /* Klaviyo SMS subscribe */
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + overlay.dataset.klaviyoPublicKey, {
            method: 'POST',
            headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  list_id: klaviyoListId,
                  channels: { sms: ['MARKETING'] },
                  profile: { data: { type: 'profile', attributes: { phone_number: '+1' + digits } } }
                }
              }
            })
          }).then(showSuccess).catch(showSuccess);
        } else if (smsEndpoint) {
          fetch(smsEndpoint, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ phone: digits })
          }).then(showSuccess).catch(showSuccess);
        } else {
          /* fallback: Shopify contact form, no redirect */
          var fd = new FormData();
          fd.append('form_type', 'contact');
          fd.append('utf8', '✓');
          fd.append('contact[phone]', digits);
          fd.append('contact[body]', 'SMS drop alert signup — Capsule-1');
          fetch('/contact', { method: 'POST', body: fd })
            .then(showSuccess).catch(showSuccess);
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (skipLink) skipLink.addEventListener('click', function (e) { e.preventDefault(); close(); });

    /* close on backdrop click */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    /* expose open for CTA buttons */
    document.querySelectorAll('[data-open-intro]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (successWrap) successWrap.style.display = 'none';
        if (formWrap) formWrap.style.display = '';
        open();
      });
    });

    /* auto-open once per session */
    if (!sessionStorage.getItem(SESSION_KEY)) {
      setTimeout(function () {
        sessionStorage.setItem(SESSION_KEY, '1');
        open();
      }, 900);
    }
  }

  /* ── init on DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initNav();
    initCountdown();
    initIntro();
  }
})();
